import { billLineLabels, type PosSale } from '../api/pos';

/** Past this many lines a bill row is summarised rather than listed out. */
const MAX_TITLES = 3;

/**
 * What was actually on a bill, under its row.
 *
 * Staff recognise a sale by what was in it long before they recognise it by
 * its number — "the one with the two Malayalam novels" is how a customer at
 * the counter describes the bill they want reprinted. So the titles are what
 * make a row findable at a glance.
 *
 * A long bill is cut short rather than allowed to push every other row off
 * the screen; the full list is one tap away in the bill itself, and the whole
 * of it is on the hover title for a counter with a mouse.
 */
export default function BillTitles({ sale }: { sale: PosSale }) {
  const labels = billLineLabels(sale);
  if (labels.length === 0) return null;

  const shown = labels.slice(0, MAX_TITLES);
  const rest = labels.length - shown.length;

  return (
    <span className="bill-titles" title={labels.join(', ')}>
      {shown.join('  ·  ')}
      {rest > 0 && <span className="bill-more"> +{rest} more</span>}
    </span>
  );
}
